import moment from 'moment';

export type StatisticsDateRangeValue = {
    startDate: moment.Moment;
    endDate: moment.Moment;
};

export type StatisticsDateRangePreset = {
    labelKey: string;
    getRange: () => StatisticsDateRangeValue;
};

/**
 * Default quick-select time ranges for the statistics date pickers.
 * Mirrors the selections available in the old UI: Last Week, Last Month,
 * Last Quarter, Last Half Year and Last Year.
 *
 * All ranges are calendar based and never extend beyond yesterday, because
 * statistics data is only collected up to (and including) yesterday - which
 * is also the date picker's maxDate.
 */
export const STATISTICS_DATE_RANGE_PRESETS: StatisticsDateRangePreset[] = [
    {
        labelKey: 'Last Week',
        getRange: () => {
            const yesterday = moment().subtract(1, 'days');
            return {
                startDate: moment(yesterday).subtract(7, 'days').startOf('week'),
                endDate: moment(yesterday).subtract(7, 'days').endOf('week'),
            };
        },
    },
    {
        labelKey: 'Last Month',
        getRange: () => {
            const yesterday = moment().subtract(1, 'days');
            return {
                startDate: moment(yesterday).subtract(1, 'month').startOf('month'),
                endDate: moment(yesterday).subtract(1, 'month').endOf('month'),
            };
        },
    },
    {
        labelKey: 'Last Quarter',
        getRange: () => {
            const yesterday = moment().subtract(1, 'days');
            return {
                startDate: moment(yesterday).subtract(1, 'quarter').startOf('quarter'),
                endDate: moment(yesterday).subtract(1, 'quarter').endOf('quarter'),
            };
        },
    },
    {
        labelKey: 'Last Half Year',
        getRange: () => {
            const yesterday = moment().subtract(1, 'days');
            return {
                startDate: moment(yesterday).subtract(2, 'quarters').startOf('quarter'),
                endDate: moment(yesterday).subtract(1, 'quarter').endOf('quarter'),
            };
        },
    },
    {
        labelKey: 'Last Year',
        getRange: () => {
            const yesterday = moment().subtract(1, 'days');
            return {
                startDate: moment(yesterday).subtract(1, 'year').startOf('year'),
                endDate: moment(yesterday).subtract(1, 'year').endOf('year'),
            };
        },
    },
];
